import { ProductParagraph, Spacing } from '@issuu/silkscreen';
import React from 'react';
const Paragraph = props => (React.createElement(Spacing, { bottom: 2, top: 2 },
    React.createElement(ProductParagraph, { step: "1" }, props.children)));
export default Paragraph;
//# sourceMappingURL=Paragraph.js.map